import React from "react";
import styled ,{keyframes} from "styled-components";
import { ResponsiveImage } from '../ResponsiveImage';

const moveAndFade = keyframes`
  from{
    top: -200px;
    opacity:0;
  }
  to{
    opacity:1;
    top: 0px;
  }
`;

const Image = styled(ResponsiveImage)`
  height: 40%;
  width: 40%;
  border-radius: 50%;
  border-color: #333;
  border-width: 0px;
  border-style: solid;
  box-shadow: 1px 1px 6px 1px #aeaeae;
  min-width:150px;
  min-height:150px;
  max-width:230px;
  max-height:230px;
  position: relative;
  top: ${(props) => props.offset ? `-${props.offset}px` : '0px'};
  animation: ${moveAndFade} 4s;
`;

export default function Avatar({images,offset}) {
  return <Image alt="Avatar" images={images} offset={offset}/>;
}
